export default "__VITE_ASSET__CceUhmLj__"